module.exports = __webpack_public_path__ + "img/3-3.0e9aa36f.png";